import api from './api';

export const fetchPublication = async () => {
    try {
        const response = await api.get(`/publication`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const fetchProfile = async () => {
    try {
        const response = await api.get(`/profile/detail`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};

export const updateProfile = async (formData) => {
    try {
        const response = await api.post('/profile/update', formData);  // Directly send formData
        
        return response.data.data;
    } catch (error) {
        console.error('Error updating profile:', error);
        throw error;  // Rethrow to be caught by the component
    }
};

export const getNotifications = async () => {
    try {
        const response = await api.get(`/notification/get`);
        
        return response.data;
    } catch (error) {
        console.error('Error fetching notification:', error);
        throw error;  // Rethrow to be caught by the component
    }
}

export const readNotification = async (id) => {
    try {
        const response = await api.post(`/notification/read/${id}`);
        
        return response.data;
    } catch (error) {
        console.error('Error reading notification:', error);
        throw error;  // Rethrow to be caught by the component
    }
}